import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import React, { useEffect, useState } from "react";

import { AppDispatch, RootState } from "../../core/data/redux/store";
import {
  cardPayment,
  getPaymentAccount,
  addPaymentAccount,
  manualPayment,
  resetPaymentAccount,
  otherPayment,
} from "../../core/data/redux/action";
import { fetchSavedCards } from "../../core/data/redux/actions/StripeCardActions";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import Loader from "../../core/data/img/car_loading.json";

const BookingPayment = (bookingInfo: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedCard, setSelectedCard] = useState<string | null>(null);
  const [paymentType, setPaymentType] = useState("card");
  const [Error, setError] = useState<boolean>(false);
  const [selectedCashID, setSelectedCashID] = useState("");
  const [selectedZelleIdentifier, setSelectedZelleIdentifier] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");

  const {
    cardPaymentLoading,
    cardPaymentSuccess,
    cardPaymentError,
    manualPaymentLoading,
    manualPaymentError,
    otherPaymentLoading,
    otherPaymentError,
    otherPaymentSuccess,
    savePayoutAccountError,
    savedData,
    manualPaymentSuccess,
    payoutAccountList,

    bookingsSuccess,
  } = useSelector((state: RootState) => ({
    bookingsSuccess: state.booking.bookingsSuccess,
    payoutAccountList: state.payout.payoutAccountList,
    savedData: state.payout.savedData,
    savePayoutAccountError: state.payout.savePayoutAccountError,
    otherPaymentLoading: state.payout.otherPaymentLoading,
    otherPaymentError: state.payout.otherPaymentError,
    otherPaymentSuccess: state.payout.otherPaymentSuccess,
    manualPaymentSuccess: state.payout.manualPaymentSuccess,
    manualPaymentError: state.payout.manualPaymentError,
    manualPaymentLoading: state.payout.manualPaymentLoading,
    cardPaymentSuccess: state.payout.cardPaymentSuccess,
    cardPaymentError: state.payout.cardPaymentError,
    cardPaymentLoading: state.payout.cardPaymentLoading,
  }));

  const closeModal = () => {
    const modalElement = document.getElementById("make_payment");

    if (modalElement) {
      modalElement.classList.remove("show");
    }

    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };

  useEffect(() => {
    if (cardPaymentSuccess || manualPaymentSuccess || otherPaymentSuccess) {
      closeModal();
    }
  }, [cardPaymentSuccess, manualPaymentSuccess, otherPaymentSuccess]);

  useEffect(() => {
    dispatch(fetchSavedCards());
  }, []);

  useEffect(() => {
    if (paymentType !== "card") {
      setError(false);
      setSelectedCard("");
      setSelectedCashID("");
      setSelectedZelleIdentifier("");
      dispatch(getPaymentAccount({ payment_method: paymentType }));
    }
  }, [paymentType]);

  useEffect(() => {
    if (savedData && paymentType !== "card") {
      dispatch(
        manualPayment({
          booking_id: bookingInfo.bookings?.id,
          payout_account_id: savedData?.id,
        })
      );

      dispatch(resetPaymentAccount());
    }
  }, [savedData]);

  useEffect(() => {
    if (
      savePayoutAccountError ||
      otherPaymentError ||
      manualPaymentError ||
      cardPaymentError
    ) {
      setToastMessage("");
      showToast(
        savePayoutAccountError ||
          otherPaymentError ||
          manualPaymentError ||
          cardPaymentError
      );
    }

    if (cardPaymentSuccess || manualPaymentSuccess || otherPaymentSuccess) {
      dispatch(resetPaymentAccount());
      setToastMessage("");
      showToast(
        cardPaymentSuccess || manualPaymentSuccess || otherPaymentSuccess
      );
    }
  }, [
    savePayoutAccountError,
    cardPaymentSuccess,
    manualPaymentSuccess,
    otherPaymentError,
    otherPaymentSuccess,
    manualPaymentError,
  ]);

  const handleConfirm = () => {
    if (paymentType === "card") {
      dispatch(
        cardPayment({
          booking_id: bookingInfo.bookings?.id,
        })
      );
    } else if (paymentType === "cashapp" && selectedCashID) {
      dispatch(
        addPaymentAccount({
          payment_method: paymentType,
          cashapp_id: selectedCashID,
        })
      );
    } else if (paymentType === "zelle" && selectedZelleIdentifier) {
      dispatch(
        addPaymentAccount({
          payment_method: paymentType,
          zelle_identifier: selectedZelleIdentifier,
        })
      );
    } else {
      if (selectedCard) {
        dispatch(
          manualPayment({
            booking_id: bookingInfo.bookings?.id,
            payout_account_id: selectedCard,
          })
        );
      } else {
        setError(true);
        setToastMessage("");
        showToast("The payout account id field is required");
      }
    }
  };

  const handlePaylater = () => {
    if (customerNotes) {
      dispatch(
        otherPayment({
          booking_id: bookingInfo.bookings?.id,
          customer_notes: customerNotes,
        })
      );
    } else {
      setError(true);
      setToastMessage("");
      showToast("The customer notes field is required.");
    }
  };

  const [toastMessage, setToastMessage] = useState("");
  const [toastClass, setToastClass] = useState("bg-success text-white");

  const showToast = (message: any) => {
    setToastClass(
      savePayoutAccountError ||
        otherPaymentError ||
        manualPaymentError ||
        cardPaymentError ||
        Error
        ? "bg-danger text-white"
        : "bg-success text-white"
    );

    setToastMessage(message);
  };

  const handleCloseToast = () => {
    setToastMessage("");
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === "bg-danger text-white") {
        toast.error(toastMessage, {
          position: "top-right",
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: "",
        });
      } else {
        toast.success(toastMessage, {
          position: "top-right",
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: "",
        });
      }
    }
  }, [toastMessage, toastClass]);

 
  return (
    <div>
 {toastMessage &&   <ToastContainer autoClose={3000} limit={1} /> }
      {bookingsSuccess ? (
        <div className="d-flex justify-content-center align-items-center">
          <Lottie
            animationData={Loader}
            loop={true}
            style={{ width: 300, height: 300 }}
          />
        </div>
      ) : (
        <div className="booking-detail-info">
          <div className="row">
            <div className="col-lg-12">
              <div className="booking-information-main">
                <form>
                  <div className="booking-information-card  ">
                    <div className="booking-info-body">
                      <div className="payment-method-types">
                        <p>Select Payment Method</p>

                        <ul className="booking-radio-btns">
                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input
                                type="radio"
                                name="payment_type"
                                value="card"
                                checked={paymentType === "card"}
                                onChange={() => setPaymentType("card")}
                              />
                              <span className="d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath
                                    src={`assets/img/icons/payment-3.svg`}
                                    width={"40"}
                                    alt="Img"
                                  />{" "}
                                  Card
                                </span>
                              </span>
                            </label>
                          </li>
                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input
                                type="radio"
                                name="payment_type"
                                value="cashapp"
                                onChange={() => setPaymentType("cashapp")}
                                checked={paymentType === "cashapp"}
                              />
                              <span className="d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath
                                    src={`assets/img/icons/cash-app.svg`}
                                    width={"40"}
                                    alt="Img"
                                  />{" "}
                                  CashAPP
                                </span>

                                {paymentType === "cashapp" && (
                                  <div className="d-flex flex-column gap-2">
                                    <input
                                      type="text"
                                      value={selectedCashID}
                                      placeholder="Cashtag"
                                      onChange={(e) => {
                                        setSelectedCashID(e.target.value);
                                        setError(false);
                                      }}
                                      className={`form-control py-2 ${Error ? "is-invalid" : ""}`}
                                    />

                                    <p>
                                      {" "}
                                      {Error
                                        ? "Enter your id we will charge you later"
                                        : ""}{" "}
                                    </p>
                                  </div>
                                )}
                              </span>
                            </label>
                          </li>
                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input
                                type="radio"
                                name="payment_type"
                                value="zelle"
                                onChange={() => setPaymentType("zelle")}
                                checked={paymentType === "zelle"}
                              />
                              <span className=" d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center">
                                  <ImageWithBasePath
                                    src={`assets/img/icons/zelle.svg`}
                                    width={"40"}
                                    alt="Img"
                                  />{" "}
                                  Zelle
                                </span>

                                {paymentType === "zelle" && (
                                  <div className="d-flex flex-column gap-2">
                                    <input
                                      type="text"
                                      value={selectedZelleIdentifier}
                                      placeholder="Email or phone"
                                      onChange={(e) => {
                                        setSelectedZelleIdentifier(
                                          e.target.value
                                        );
                                        setError(false);
                                      }}
                                      className={`form-control py-2 ${Error ? "is-invalid" : ""}`}
                                    />
                                    <p>
                                      {" "}
                                      {Error
                                        ? "Enter your id we will charge you later"
                                        : ""}{" "}
                                    </p>
                                  </div>
                                )}
                              </span>
                            </label>
                          </li>

                          <li>
                            <label className="d-flex gap-2 align-items-center">
                              <input
                                type="radio"
                                name="payment_type"
                                value="other"
                                onChange={() => setPaymentType("other")}
                                checked={paymentType === "other"}
                              />
                              <span className="  w-100 d-flex gap-2 align-items-center">
                                <span className="d-flex gap-2 align-items-center px-2">
                                  <ImageWithBasePath
                                    src={`assets/img/icons/dollar.svg`}
                                    width={"30"}
                                    alt="Img"
                                  />
                                  <span className="ps-1"> Other </span>
                                </span>

                                {paymentType === "other" && (
                                  <input
                                    type="text"
                                    value={customerNotes}
                                    placeholder="notes"
                                    onChange={(e) => {
                                      setCustomerNotes(e.target.value);
                                      setError(false);
                                    }}
                                    className={`form-control py-2 ${Error ? "is-invalid" : ""}`}
                                  />
                                )}
                              </span>
                            </label>
                          </li>
                        </ul>
                      </div>

                      {paymentType === "card" && (
                        <>
                          <div className="py-1 d-flex align-items-center">
                            <label>
                              RefId: {bookingInfo?.bookings?.reference_id}
                            </label>
                          </div>
                          <div className="py-1">
                            <p className="text-justify">
                              After your reservation is confirmed, you&lsquo;ll
                              receive a secure payment link to complete your
                              booking.
                            </p>
                          </div>

                          <div className="booking-info-btns d-flex d-md-grid justify-content-end pt-0">
                            <button
                              onClick={handleConfirm}
                              disabled={cardPaymentLoading}
                              className="btn btn-primary mt-1"
                              type="button"
                            >
                              Place Reservation
                            </button>
                          </div>
                        </>
                      )}

                      {paymentType === "cashapp" && (
                        <>
                          {payoutAccountList?.length > 0 && (
                            <div>
                              <p> CashApp Accounts</p>
                            </div>
                          )}

                          <div className="payment-method-types payments-cards-types">
                            <div className="row">
                              <div className="col-lg-7">
                                <ul>
                                  {payoutAccountList?.length > 0 ? (
                                    payoutAccountList?.map((card: any) => (
                                      <li key={card.id}>
                                        <label className="payment_custom_check">
                                          <input
                                            type="radio"
                                            name="payment_card"
                                            id="debit_card"
                                            value={card.id}
                                            checked={selectedCard === card.id}
                                            onChange={() => {
                                              setSelectedCard(card.id);
                                              setSelectedCashID(
                                                card?.cashapp_id
                                              );
                                            }}
                                          />
                                          <span
                                            className="payment_checkmark align-items-center py-0"
                                            style={{
                                              minHeight: 40,
                                            }}
                                          >
                                            <span className="checked-title">
                                              <ImageWithBasePath
                                                src={`assets/img/icons/cash-app.svg`}
                                                alt="Img"
                                              />
                                            </span>
                                            <small>
                                              {(card?.cashapp_id || "Unknown")
                                                .charAt(0)
                                                .toUpperCase() +
                                                (
                                                  card?.cashapp_id || "Unknown"
                                                ).slice(1)}
                                            </small>
                                          </span>
                                        </label>
                                      </li>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </ul>

                                <div className="py-1 d-flex align-items-center">
                                  <label>
                                    RefId: {bookingInfo?.bookings?.reference_id}
                                  </label>
                                </div>
                                <div className="py-1">
                                  <p className="text-justify">
                                    After submission, our team will send a
                                    payment request. Please complete the payment
                                    and notify us once done.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="text-center booking-info-btns d-flex d-md-grid justify-content-end pt-0">
                              <button
                                onClick={handleConfirm}
                                disabled={manualPaymentLoading}
                                className="btn btn-primary "
                                type="button"
                              >
                                Place Reservation
                              </button>

                              <p className="mt-1">Pay at check-in</p>
                            </div>
                          </div>
                        </>
                      )}

                      {paymentType === "zelle" && (
                        <>
                          {payoutAccountList?.length > 0 && (
                            <div>
                              {" "}
                              <p> Zelle Accounts</p>{" "}
                            </div>
                          )}

                          <div className="payment-method-types payments-cards-types">
                            <div className="row">
                              <div className="col-lg-7">
                                <ul>
                                  {payoutAccountList?.length > 0 ? (
                                    payoutAccountList?.map((card: any) => (
                                      <li key={card.id}>
                                        <label className="payment_custom_check">
                                          <input
                                            type="radio"
                                            name="payment_card"
                                            id="debit_card"
                                            value={card.id}
                                            checked={selectedCard === card.id}
                                            onChange={() => {
                                              setSelectedCard(card.id);
                                              setSelectedZelleIdentifier(
                                                card?.zelle_identifier
                                              );
                                            }}
                                          />
                                          <span
                                            className="payment_checkmark align-items-center py-0"
                                            style={{
                                              minHeight: 40,
                                            }}
                                          >
                                            <span className="checked-title">
                                              <ImageWithBasePath
                                                src={`assets/img/icons/zelle.svg`}
                                                alt="Img"
                                              />
                                            </span>
                                            <small>
                                              {(
                                                card?.zelle_identifier ||
                                                "Unknown"
                                              )
                                                .charAt(0)
                                                .toUpperCase() +
                                                (
                                                  card?.zelle_identifier ||
                                                  "Unknown"
                                                ).slice(1)}
                                            </small>
                                          </span>
                                        </label>
                                      </li>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </ul>
                              </div>
                            </div>

                            <>
                              <div className="py-1 d-flex align-items-center">
                                <label>
                                  RefId: {bookingInfo?.bookings?.reference_id}
                                </label>
                              </div>
                              <div className="py-1">
                                <p className="text-justify">
                                  After submission, our team will send a payment
                                  request. Please complete the payment and
                                  notify us once done.
                                </p>
                              </div>
                            </>

                            <div className="text-center booking-info-btns d-flex d-md-grid justify-content-end pt-0">
                              <button
                                onClick={handleConfirm}
                                disabled={manualPaymentLoading}
                                className="btn btn-primary"
                                type="button"
                              >
                                Place Reservation
                              </button>
                              <p className="mt-1">Pay at check-in</p>
                            </div>
                          </div>
                        </>
                      )}

                      {paymentType === "other" && (
                        <>
                          <div className="payment-method-types payments-cards-types">
                            <>
                              <div className="py-1 d-flex align-items-center">
                                <label>
                                  RefId: {bookingInfo?.bookings?.reference_id}
                                </label>
                              </div>
                            </>

                            <div className="text-center booking-info-btns d-flex d-md-grid justify-content-end pt-0">
                              <button
                                onClick={handlePaylater}
                                disabled={otherPaymentLoading}
                                className="btn btn-primary"
                                type="button"
                              >
                                Place Reservation
                              </button>

                              <p className="mt-1">Pay at check-in</p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingPayment;
